var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProjectIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 18,
    viewBox: "0 0 23 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2512_5216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2119 2.20337H3.70215",
    stroke: "#76808D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.530762 15.0481H0.546619C0.546619 15.0957 0.530762 15.1512 0.530762 15.1987C0.530762 16.1185 1.27607 16.8638 2.19582 16.8638H19.6631C20.5828 16.8638 21.3281 16.1185 21.3281 15.1987C21.3281 15.1432 21.3202 15.0957 21.3123 15.0481H21.3281",
    stroke: "#76808D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.57544 0.48291H2.19582C1.27607 0.48291 0.530762 1.22822 0.530762 2.14797C0.530762 2.16383 0.530762 2.18761 0.530762 2.20347V15.0482H0.546619C0.625908 14.1998 1.33158 13.5338 2.19582 13.5338H3.57544V0.48291Z",
    stroke: "#76808D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3284 2.14797C21.3284 1.22822 20.5831 0.48291 19.6633 0.48291H18.2837V13.5417H19.6633C20.5276 13.5417 21.2332 14.2077 21.3125 15.0561H21.3284V2.20347C21.3284 2.20347 21.3284 2.16383 21.3284 2.14797Z",
    stroke: "#76808D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4894 13.0423L8.25342 14.2078L8.30892 11.6626C8.30892 11.4961 8.36442 11.3296 8.45164 11.1869L12.3209 5.11341C12.4478 4.90726 12.6777 4.78833 12.9156 4.78833H13.7798C14.0573 4.78833 14.3111 4.95484 14.43 5.20856L14.763 5.9618C14.8582 6.17588 14.8423 6.4296 14.7154 6.62782L10.8382 12.7251C10.751 12.8599 10.6321 12.9709 10.4814 13.0502L10.4894 13.0423Z",
    stroke: "#76808D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0415 5.05786L10.085 11.2662",
    stroke: "#76808D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6398 12.7568L10.3147 11.9322C10.1641 11.5596 9.79935 11.3296 9.40291 11.3455L8.49902 11.3931",
    stroke: "#76808D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2512_5216"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.5903,
    height: 17.1818,
    fill: "white",
    transform: "translate(0.134277 0.0864258)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectIcon);
export default __webpack_public_path__ + "static/media/project-icon.f3ee44b5f57fcab6cc8efb54e02d8ca2.svg";
export { ForwardRef as ReactComponent };